/**
 * plugins/vuetify.ts
 *
 * Framework documentation: https://vuetifyjs.com`
 */

// Styles
import '@mdi/font/css/materialdesignicons.css'
import '@fortawesome/fontawesome-pro/css/all.css'
import 'vuetify/styles'

// Composables
import { createVuetify } from 'vuetify'
import { aliases, fa } from 'vuetify/iconsets/fa'
import { mdi } from 'vuetify/iconsets/mdi'
import {
  VStepperVertical,
  VStepperVerticalItem
} from 'vuetify/labs/VStepperVertical'

// https://vuetifyjs.com/en/introduction/why-vuetify/#feature-guides
export default createVuetify({
  components: {
    VStepperVertical,
    VStepperVerticalItem
  },
  icons: {
    defaultSet: 'fa',
    aliases,
    sets: {
      fa,
      mdi
    }
  },
  theme: {
    defaultTheme: 'light',
    themes: {
      light: {
        colors: {
          background: '#FFF',
          surface: '#FFF',
          primary: '#444CE7',
          secondary: '#101828',
          tertiary: '#475467',
          error: '#D92D20',
          info: '#15B79E',
          warning: '#DC6803',
          success: '#039855',
          'coming-soon': '#FF7272'
        }
      }
    }
  }
})
